import { ThemeProps } from 'styled-components';
import { styled } from '../../../common.styles';
import { baseColor, mobile, normalFont, primaryFont, tablet, Theme } from '../../../styles/general/theme';

const sizeBig =
  (adjustment = 0) =>
  (p: ThemeProps<Theme>) =>
    p.theme.fontSize.big + adjustment;
const sizeLarge =
  (adjustment = 0) =>
  (p: ThemeProps<Theme>) =>
    p.theme.fontSize.large + adjustment;
const sizeExtraLarge =
  (adjustment = 0) =>
  (p: ThemeProps<Theme>) =>
    p.theme.fontSize.extraLarge + adjustment;

const BaseText = styled.div`
  color: ${baseColor(100)};
`;

const BaseDisplay = styled(BaseText)`
  font-family: ${(p) => p.theme.font.accent};
`;

const Display5 = styled(BaseDisplay)`
  font-size: ${(p) => p.theme.fontSize.huge}px;
  line-height: ${(p) => p.theme.fontSize.huge - 6}px;

  @media (max-width: ${tablet}px) {
    font-size: ${sizeExtraLarge()}px;
    line-height: 1;
  }

  @media (max-width: ${mobile}px) {
    font-size: ${sizeLarge()}px;
    line-height: 1;
  }
`;

const Display4 = styled(BaseDisplay)`
  font-size: ${(p) => p.theme.fontSize.huge}px;
  line-height: ${(p) => p.theme.fontSize.huge - 6}px;
`;

const Display3 = styled(BaseDisplay)`
  font-size: ${sizeExtraLarge(-4)}px;
  line-height: ${sizeExtraLarge(-2)}px;
`;

const Display2 = styled(BaseDisplay)`
  font-size: ${sizeLarge()}px;
  line-height: ${sizeLarge(4)}px;
`;

const Display1 = styled(BaseDisplay)`
  font-size: ${sizeBig()}px;
  line-height: ${sizeBig(3)}px;
`;

const BaseTitle = styled(BaseText)`
  font-family: ${primaryFont};
`;

const Title3 = styled(BaseTitle)`
  font-size: ${sizeLarge()}px;
  line-height: ${sizeBig(3)}px;
`;

const Title2 = styled(BaseTitle)`
  font-size: ${sizeLarge(-3)}px;
  line-height: ${sizeLarge()}px;
`;

const Title1 = styled(BaseTitle)`
  font-size: ${sizeBig()}px;
  line-height: ${sizeBig(3)}px;
`;

const BaseBody = styled(BaseText)`
  font-family: ${normalFont};
  line-height: ${sizeBig(3)}px;
`;

const Body4 = styled(BaseBody)`
  font-size: ${(p) => p.theme.fontSize.big};
  line-height: 1.3333;
`;

const Body3 = styled(BaseBody)`
  font-size: ${(p) => p.theme.fontSize.normal}px;
  font-weight: bold;
`;

const Body2 = styled(BaseBody)`
  font-size: ${(p) => p.theme.fontSize.normal}px;
`;

const Body1 = styled(BaseBody)`
  font-size: ${(p) => p.theme.fontSize.small}px;
`;

export const CommonTypography = {
  Display5,
  Display4,
  Display3,
  Display2,
  Display1,
  Title3,
  Title2,
  Title1,
  Body4,
  Body3,
  Body2,
  Body1,
};
